import React, { FC } from 'react';
import useRootSelector from 'common/hooks/useRootSelector';
import { Avatar, makeStyles } from '@material-ui/core';
import { ReactComponent as DefaultIcon } from 'img/icons/default-icon.svg';
import { INamedEntityImt } from 'common/interfaces/common';
import { HeaderId } from 'common/enums/html.enums';
import { selectUserSelectedOrganization } from 'modules/authentication/state/selectors';

const useStyles = makeStyles(() => ({
  clubLogo: {
    width: ({ orgImage }: { orgImage: string | null | undefined }) => (orgImage ? 'unset' : 36),
    height: 36,
  },
}));

const HeaderClubLogo: FC = () => {
  const selectedOrg: INamedEntityImt = useRootSelector(selectUserSelectedOrganization);
  const orgImage = selectedOrg?.get('imageUrl');
  const classes = useStyles({ orgImage });

  return (
    <Avatar
      id={HeaderId.HeaderBtnClubLogo}
      className={classes.clubLogo}
      variant={orgImage ? 'rounded' : 'circular'}
      alt={selectedOrg?.get('title')}
      src={orgImage || undefined}
    >
      <DefaultIcon />
    </Avatar>
  );
};

export default HeaderClubLogo;
